import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import { ThemeOverride, SisuContext } from '../Context';
import { ThemeOptions } from '../publicSession/types';
import CloseButtonThin from '../Primitives/CloseButton';
import CloseIconBold from '../Icons/CloseBold';
import IconButton from '../Button/IconButton';
import ErrorBoundary from '../ErrorBoundary';
import s from './Popup.scss';
var Popup = /** @class */ (function (_super) {
    tslib_1.__extends(Popup, _super);
    function Popup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Popup.prototype.render = function () {
        var _a = this.props, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onRequestClose = _a.onRequestClose, width = _a.width, height = _a.height, className = _a.className, closeBtnClassName = _a.closeBtnClassName, closeBtnSize = _a.closeBtnSize, _c = _a.contentClassName, contentClassName = _c === void 0 ? className : _c, contentLabel = _a.contentLabel, disableAriaHide = _a.disableAriaHide, withCloseButton = _a.withCloseButton, overlayClassName = _a.overlayClassName, children = _a.children;
        var style = {
            content: {
                width: width || false,
                height: height || false,
            },
        };
        return (React.createElement(Modal, { isOpen: isOpen, onRequestClose: onRequestClose, className: classnames(s['modal'], className), overlayClassName: classnames(s['overlay'], overlayClassName), contentLabel: contentLabel, style: style, ariaHideApp: !disableAriaHide },
            React.createElement(ThemeOverride, { className: contentClassName, theme: ThemeOptions.LIGHT },
                withCloseButton && (React.createElement(SisuContext.Consumer, null, function (isSisu) {
                    return isSisu ? (React.createElement(CloseButtonThin, { className: classnames(s['sisu-close-button'], closeBtnClassName), onClick: onRequestClose })) : (React.createElement(IconButton, { className: s['close-button'], onClick: onRequestClose, noHoverEffect: true },
                        React.createElement(CloseIconBold, { className: closeBtnClassName, size: closeBtnSize })));
                })),
                React.createElement(ErrorBoundary, null, children || null))));
    };
    Popup.defaultProps = {
        withCloseButton: true,
    };
    return Popup;
}(React.Component));
export default Popup;
//# sourceMappingURL=Popup.js.map